module.exports = __webpack_public_path__ + "static/media/tm6_5.b42ccd70.png";